import { useAuth } from '@polvo-labs/react-auth'
import React from 'react'
import { useHistory } from 'react-router-dom'
import Button from '../../../components/Button'
import Icon from '../../../components/Icon'
import Private from '../../../components/Private'
import Text from '../../../components/Text'
import routes from '../../../config/routes'
import AccountForm from '../../../forms/Account'
import { Container } from './styles'

interface Props {

}

const AccountScreen: React.FC<Props> = () => {
  const { user } = useAuth()
  const history = useHistory()

  if (user && user.gender === '') {
    user.gender = null
  }

  return (
    <Private>
      <Container>
        <Text
          tag="h1"
        >
          <Button
            label={(
              <Icon
                name="close"
              />
            )}
            small
            backgroundColor="transparent"
            onClick={() => history.push(routes.settings.index.path)}
          />
          {' '}Minha conta
        </Text>

        <AccountForm
          initialValues={user}
        />
      </Container>
    </Private>
  )
}

export default AccountScreen
